export const RootRoute = "/";
export const PreviewInsoleRoute = "/preview-insole";
export const ScanInProgressRoute = "/scan-in-progress";
export const PersonalizationRoute = "/personalization";
export const AppHandoffRoute = RootRoute;
